// extracted by mini-css-extract-plugin
export default {"footer":"fKbib","footer__list":"zkOvB","footer__item":"_64yxh","footer__link":"Nk44e","footer__copy":"cH315"};